import PhotoSwipe from "photoswipe";

document.addEventListener("DOMContentLoaded", (event) => {
  initPhotoSwipe();
});

function initPhotoSwipe(){
  
}